var pluginsJS = {};

(function ($) {

	pluginsJS.Marquee = function () {
		var ticker = $('.js-ticker');

		// Remove logos that are not png or cannot be loaded
		var jobImages = $('.job-list img');
		jobImages.each(function (index, value) {
			var element = $(value);

			if (element.prop('src').indexOf('.png') === -1) {
				element.parents('.job-list').remove();
			}
		});

		jobImages.on('error', function () {
			var element = $(this);
			element.off('error');
			element.parents('.job-list').remove();
		});

		// Rerun selector
		jobImages = $(jobImages.selector);

		if (jobImages.length) {
			ticker.marquee({
				pauseOnHover: true,
				gap: 0,
				delayBeforeStart: 3000,
				duration: ticker.data('duration')
			});
		}
	};

	// pluginsJS.Quote = function () {
	// 	$( ".js-quote-slider" ).slick( {
	// 		arrows: false,
	// 		dots: true,
	// 		infinite: true,
	// 		slidesToShow: 2,
	// 		slidesToScroll: 2,
	// 		autoplay: true,
	// 		autoplaySpeed: 10000,
	// 		responsive: [ {
	// 			breakpoint: 767,
	// 			settings: {
	// 				slidesToShow: 1,
	// 				slidesToScroll: 1
	// 			}
	// 		} ]

	// 	} );
	// };

	// pluginsJS.quoteBtn = function () {
	// 	$( '.js-quote-btn' ).on( 'click', function () {
	// 		if ( $( ".navbar-toggle" ).is( ":visible" ) ) {
	// 			$( this ).parent( '.slick-active .slick-content' ).removeClass( 'show-less' );
	// 			$( this ).parent( '.slick-active .slick-content' ).find( '.quote-readmore' ).hide();
	// 			$( this ).parents( '.slick-active' ).css( { 'margin-bottom': 0 } );
	// 			$( this ).hide();
	// 		}
	// 	} );
	// };

	// pluginsJS.Quotebutton = function () {
	// 	if ( $( ".navbar-toggle" ).is( ":visible" ) ) {
	// 		$( '.js-quote-btn, .quote-readmore' ).show();
	// 		$( '.slick-content' ).addClass( 'show-less' );
	// 		$( '.slick-slide' ).css( { 'margin-bottom': '60px' } );
	// 		pluginsJS.quoteBtn();
	// 	}


	// 	$( '.js-quote-slider' ).on( 'afterChange', function ( event, slick ) {
	// 		if ( $( ".navbar-toggle" ).is( ":visible" ) ) {
	// 			$( '.js-quote-btn, .quote-readmore' ).show();
	// 			$( '.slick-content' ).addClass( 'show-less' );
	// 			$( '.slick-slide' ).css( { 'margin-bottom': '60px' } );
	// 			pluginsJS.quoteBtn();
	// 		}
	// 	} );
	// };


	var firstWord = $(".js-quote-vertical").data('firstWord');
	var separator = $(".js-quote-vertical").data('separator');

	pluginsJS.QuoteJS = function () {



		$(".js-quote-vertical").on('init', function (event, slick) {
			$(this).append('<div class="slick-counter hidden-xs hidden-sm">' + firstWord + ' <span class="current"></span> ' + separator + ' <span class="total"></span></div>');
			$('.current').text(slick.currentSlide + 1);
			$('.total').text(slick.slideCount);
		});

		$(".js-quote-vertical").slick({
			arrows: false,
			dots: true,
			vertical: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			verticalSwiping: true,
			autoplay: false,
			slide: 'div',
			cssEase: 'linear',
			responsive: [{
				breakpoint: 991,
				settings: {
					vertical: false,
					verticalSwiping: false
				}
			}]

		})
			.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
				$(this).append('<div class="slick-counter hidden-xs hidden-sm">' + firstWord + ' <span class="current"></span> ' + separator + ' <span class="total"></span></div>');
				$('.current').text(nextSlide + 1);
				$('.total').text(slick.slideCount);
			});
	};

	var maxHeight = -1;
	pluginsJS.QuoteJSHeight = function () {

		$('.js-quote-vertical .slick-slide').each(function () {
			if ($(this).height() > maxHeight) {
				maxHeight = $(this).height();
			}
		});
		$('.js-quote-vertical .slick-slide').each(function () {
			if ($(this).height() < maxHeight) {
				$(this).css('margin', Math.ceil((maxHeight - $(this).height()) / 2) + 'px 0');
			}
		});
	};

	$(document).ready(function () {

		if (window.navigator.userAgent.indexOf("MSIE 9.0") !== -1 && window.navigator.appName === "Microsoft Internet Explorer") {
		} else {
			pluginsJS.Marquee();
		}

		pluginsJS.QuoteJS();
		pluginsJS.QuoteJSHeight();
	});

	$(window).resize(function () {
		$(".js-quote-vertical").slick('refresh');
		pluginsJS.QuoteJSHeight();
	});

})(jQuery);
